module.exports = __webpack_public_path__ + "img/alarm-notice.1e532d4e.png";